import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, formatApiErrorDetail } from "../lib/api";

const EMPTY = { current: "", a: "", b: "" };

export const ChangePasswordButton = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const close = () => { setOpen(false); setF(EMPTY); setError(""); };
  const submit = async (e) => {
    e.preventDefault();
    if (f.a !== f.b) { setError("As senhas novas não conferem."); return; }
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/change-password", { current: f.current, password: f.a });
      toast.success("Senha alterada");
      close();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <button data-testid="change-password-btn" onClick={() => setOpen(true)} title="Alterar senha"
        className="p-2 rounded-md hover:bg-[#21252F] text-[#9CA3AF] hover:text-white transition-colors"><KeyRound className="w-4 h-4" /></button>
      <Dialog open={open} onOpenChange={(o) => !o && close()}>
        <DialogContent data-testid="change-password-dialog" className="bg-[#181B21] border-[#2D333F] max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-heading">Alterar senha</DialogTitle>
            <DialogDescription>Use pelo menos 6 caracteres.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            {[["current", "Senha atual"], ["a", "Nova senha"], ["b", "Repita a nova senha"]].map(([k, l]) => (
              <div key={k} className="space-y-1.5">
                <Label>{l}</Label>
                <Input data-testid={`change-password-${k}`} type="password" required minLength={k === "current" ? 1 : 6} value={f[k]}
                  onChange={(e) => setF({ ...f, [k]: e.target.value })} className="bg-[#0F1115] border-[#2D333F]" />
              </div>
            ))}
            {error && <p data-testid="change-password-error" className="text-sm text-red-400">{error}</p>}
            <DialogFooter>
              <Button type="button" variant="ghost" onClick={close}>Cancelar</Button>
              <Button data-testid="change-password-submit" disabled={busy} className="bg-[#E67E22] hover:bg-[#D35400] text-black font-semibold">
                {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Salvar
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
